import styled from 'styled-components';
import { Box as MuiBox, Typography as MuiTypography } from '@mui/material';

export const ResponseContainer = styled(MuiBox)`
  && {
    background-color: ${({theme}) => theme.palette.colors.white};
    padding: 5px;
    border-radius: 5px;
    border: 1px solid ${({theme}) => theme.palette.colors.gray200};
    margin-top: 10px;
  }
`;

export const SMuiBox = styled(MuiBox)`
  && {
    display: flex;
    width: 100%;
    margin-bottom: 16px;
    padding: 24px;
    border-radius: 6px;
    border: 1px solid ${({theme}) => theme.palette.colors.gray200};
  }
`;

export const SContainer = styled.div`
  && {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
`;

export const SHeader = styled(MuiBox)`
  && {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: ${({theme}) => theme.palette.colors.gray400};
  }
`;

export const SContent = styled(MuiBox)`
  && {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
`;

export const SCondition = styled(MuiTypography)`
  && {
    color: ${({theme}) => theme.palette.colors.blue100};
    padding: 1px 6px;
    background-color: ${({theme}) => theme.palette.colors.blue200};
    border-radius: 4px;
  }
`;
